'use es6';

import styled from 'foundations-theming/utils';
import emptyFunction from 'react-utils/emptyFunction';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { Box } from 'foundations-components/transitional/components/Box';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "SnowflakeFilterWrapper__Container",
  componentId: "rjghn8-0"
})(["display:flex;flex-direction:row;position:relative;background-color:", ";&:hover{background-color:", ";cursor:pointer;& .snowflake-filter-remove{visibility:visible;opacity:1;}}"], props => props.highlighted ? props.theme.color['fill-field-pressed'] : 'transparent', ({
  theme
}) => theme.color['fill-field-pressed']);
const FilterRemove = styled.div.withConfig({
  displayName: "SnowflakeFilterWrapper__FilterRemove",
  componentId: "rjghn8-1"
})(["display:flex;align-items:center;visibility:hidden;opacity:0;transition:visibility 0.3s linear,opacity 0.3s linear;"]);
const SnowflakeFilterWrapper = ({
  highlighted,
  onEdit,
  onRemove,
  readOnly,
  children
}) => {
  return (
    /*#__PURE__*/
    //@bend-expect trellis-tokenized This component is tokenized, and uses styled to apply hover styles
    _jsxs(Container, {
      "data-test-id": "snowflake-filter-wrapper",
      highlighted: highlighted,
      align: "stretch",
      onClick: readOnly || !onEdit ? emptyFunction : onEdit,
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 1,
        paddingInline: "300",
        paddingBlock: "100",
        children: children
      }), onRemove && !readOnly ?
      /*#__PURE__*/
      /*@bend-expect trellis-tokenized */
      _jsx(FilterRemove, {
        className: "snowflake-filter-remove",
        children: /*#__PURE__*/_jsx(CloseButton, {
          "data-test-id": "snowflake-filter-remove-button",
          size: "small",
          color: "icon-core-subtle",
          onClick: e => {
            e.stopPropagation();
            onRemove();
          },
          style: {
            top: 10,
            right: 10
          }
        })
      }) : null]
    })
  );
};
SnowflakeFilterWrapper.propTypes = {
  highlighted: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  readOnly: PropTypes.bool,
  children: PropTypes.any
};
export default SnowflakeFilterWrapper;